import { render, staticRenderFns } from "./deviceDetection.vue?vue&type=template&id=39528362&scoped=true&"
import script from "./deviceDetection.vue?vue&type=script&lang=js&"
export * from "./deviceDetection.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetection.vue?vue&type=style&index=0&id=39528362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39528362",
  null
  
)

export default component.exports